<dialog-draggable-header>Reason Code Maintenance</dialog-draggable-header>

<div #content mat-dialog-content>
   <data-table [data]="reasonCodes" [columns]="columns" [filterColumnDisplay]="false" [loading]="loading"
      [totalRecords]="total" (lazyLoad)="onLazyLoad($event)" [lazy]="true" [paging]="true" [pageSize]="pageOptions.size"
      (select)="updateSelectedReasonCode($event)" (edit)="updateReasonCode($event)">
      <ng-container actionStart>
         <button mat-button (click)="onAddReasonCodeClick()">Add Reason Code</button>
         <mat-divider vertical class="action-bar-vertical-divider"></mat-divider>
         <button mat-button (click)="removeHandler()" (keypress.enter)="removeHandler()">Delete Reason Code</button>
      </ng-container>
      <ng-container actionEnd>
         <button mat-dialog-close mat-button>Close</button>
      </ng-container>
   </data-table>
</div>